if (!customElements.get('samplebox-builder')) {
  customElements.define('samplebox-builder', class SampleboxBuilder extends HTMLElement {
    constructor() {
      super();

      // Element-scoped listener: dies with the element, no cleanup needed.
      this.addEventListener('change', (event) => {
        if (event.target.matches('select')) {
          this.updateSelection(event.target.closest('[data-samplebox-variant]'));
        }
      });

      // VariantSelects sets input[name="id"] and dispatches a bubbling
      // "change" on it after every variant switch (see global.js).
      this.onVariantChange = (event) => {
        if (event.target.name === 'id' && event.target.form === this.form) this.sync();
      };

      this.onPageShow = () => this.sync();

      // The product form is novalidate and submits via fetch, so required
      // alone never blocks a submit: validate in the capture phase, before
      // the form's own submit handler snapshots its FormData.
      this.onSubmitCapture = (event) => {
        if (event.target !== this.form) return;
        const active = this.activeContainer();
        if (!active) return;
        const missing = Array.from(active.querySelectorAll('select')).find((select) => !select.value);
        if (missing) {
          event.preventDefault();
          event.stopPropagation();
          missing.reportValidity();
        }
      };
    }

    connectedCallback() {
      this.containers = Array.from(this.querySelectorAll('[data-samplebox-variant]'));
      this.form = this.closest('form') || document.getElementById(this.dataset.formId);

      document.addEventListener('change', this.onVariantChange);
      window.addEventListener('pageshow', this.onPageShow);
      document.addEventListener('submit', this.onSubmitCapture, true);

      this.sync();
    }

    // Section re-renders (theme editor, combined-product swaps) recreate
    // the element; drop the document/window listeners of the old instance.
    disconnectedCallback() {
      document.removeEventListener('change', this.onVariantChange);
      window.removeEventListener('pageshow', this.onPageShow);
      document.removeEventListener('submit', this.onSubmitCapture, true);
    }

    activeContainer() {
      const id = this.form?.querySelector('input[name="id"]')?.value;
      return this.containers.find((container) => container.dataset.sampleboxVariant === id) || null;
    }

    // Only the active variant's pickers are visible and enabled. Disabled
    // controls are excluded from the form, so an inactive variant's
    // properties (including its hidden _samplebox) can never leak into
    // the cart.
    sync() {
      const active = this.activeContainer();
      this.containers.forEach((container) => {
        const isActive = container === active;
        container.style.display = isActive ? 'flex' : 'none';
        container.querySelectorAll('select, input').forEach((el) => { el.disabled = !isActive; });
        if (isActive) this.updateSelection(container);
      });
    }

    // The selects submit the human-readable names natively (value = name,
    // for the warehouse). This mirrors the chosen options' data-variant-id
    // into the hidden _samplebox input — the machine-readable id list the
    // cart transform function expands into real line items. Only written
    // once every slot is chosen: a partial id list would expand into fewer
    // items that still sum to the full box price.
    updateSelection(container) {
      if (!container) return;
      const ids = Array.from(container.querySelectorAll('select')).map((select) => {
        const option = select.selectedOptions[0];
        if (!select.value || !option) return null;
        return option.getAttribute('data-variant-id');
      });
      const summary = container.querySelector('[data-samplebox-selection]');
      if (summary) summary.value = ids.every(Boolean) ? ids.join(',') : '';
    }
  });
}
